import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/smoothScroll";
import { EASE } from "./Reveal";

const LINKS = [
  ["story", "Reinvented"],
  ["collection", "Collection"],
  ["wear", "How to wear"],
  ["order", "Order"],
];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: EASE, delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,border-color] duration-500 ${solid ? "border-b border-gold/15 bg-ink/75 backdrop-blur-xl" : "border-b border-transparent bg-ink/90 backdrop-blur-xl"}`}
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 sm:px-10">
        <button onClick={() => scrollToId("top")} data-testid="nav-logo" aria-label="Back to top">
          <Logo />
        </button>
        <nav className="flex items-center gap-8">
          {LINKS.slice(0, 3).map(([id, label]) => (
            <button key={id} onClick={() => scrollToId(id)} data-testid={`nav-link-${id}`}
              className="hidden font-mono text-[11px] uppercase tracking-[0.3em] text-stone2 transition-colors duration-300 hover:text-gold md:block">
              {label}
            </button>
          ))}
          <a href="https://hilmays-kabas.emergent.host/" target="_blank" rel="noopener noreferrer" data-testid="nav-link-heritage"
            className="hidden font-mono text-[11px] uppercase tracking-[0.3em] text-stone2 transition-colors duration-300 hover:text-gold md:block">
            Heritage
          </a>
          <button onClick={() => scrollToId("order")} data-testid="nav-order-button"
            className="rounded-full border border-gold/60 px-5 py-2 font-mono text-[11px] uppercase tracking-[0.25em] text-gold transition-[background-color,color] duration-300 hover:bg-gold hover:text-ink">
            Order
          </button>
        </nav>
      </div>
    </motion.header>
  );
};
